import * as actionTypes from "../constants/actionTypes";
import backend from "../utils/backend";
import { updateAxiosToken, backendLogOut } from "../utils/auth";
import { removeLocalItem } from "../utils/localdb";
import { getUserData } from "actions/user";

export const toggleAuthDrawer = bool => {
  return dispatch => {
    dispatch({
      type: actionTypes.AUTH_DRAWER_OPEN,
      payload: bool,
    });
  };
};

export const changeStep = step => {
  return dispatch => {
    dispatch({
      type: actionTypes.CHANGE_STEP,
      payload: step,
    });
  };
};

export const setBasicInfo = userData => {
  return dispatch => {
    return backend
      .request({
        method: "POST",
        url: "/readers/validate-email/",
        data: {
          email: userData.email,
        },
      })
      .then(response => {
        if (response.data.available) {
          dispatch({
            type: actionTypes.SET_BASIC_INFO,
            payload: userData,
          });

          dispatch({
            type: actionTypes.EMAIL_AVAILABLE,
          });
        } else {
          dispatch({
            type: actionTypes.EMAIL_NOT_AVAILABLE,
          });
        }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.EMAIL_VALIDATION_REQUEST_ERROR,
          payload: err,
        });
      });
  };
};

export const setOptionalInfo = userData => {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: actionTypes.SET_OPTIONAL_INFO,
        payload: userData,
      });

      resolve();
    });
  };
};

export const registerEmail = userData => {
  return dispatch => {
    return backend
      .request({
        method: "POST",
        url: "/readers/create-user/",
        data: userData,
      })
      .then(response => {
        dispatch({
          type: actionTypes.CREATE_USER_SUCCESS,
          payload: response.data,
        });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.CREATE_USER_ERROR,
          payload: err,
        });
      });
  };
};

export const requestPasswordReset = email => {
  return dispatch => {
    return backend
      .request({
        method: "POST",
        url: "/readers/forgot-password/",
        data: {
          email,
        },
      })
      .then(() => {
        dispatch({
          type: actionTypes.PASSWORD_RESET_REQUEST_SUCCESS,
        });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.PASSWORD_RESET_REQUEST_ERROR,
          payload: err,
        });
      });
  };
};

export const setPasswordResetInfo = (token, email) => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_PASSWORD_RESET_INFO,
      payload: {
        token,
        email,
      },
    });
  };
};

export const changePassword = (token, email, passwords) => {
  return dispatch => {
    return backend
      .request({
        method: "POST",
        url: "/readers/reset-password/",
        data: {
          token: token,
          email: email,
          password1: passwords.password1,
          password2: passwords.password2,
        },
      })
      .then(() => {
        dispatch({
          type: actionTypes.PASSWORD_RESET_SUCCESS,
        });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.PASSWORD_RESET_ERROR,
          payload: err,
        });
      });
  };
};

export const setAuthToken = authToken => {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: actionTypes.SET_AUTH_TOKEN,
        payload: authToken,
      });

      dispatch({
        type: actionTypes.LOGGED_IN_STATUS,
        payload: true,
      });

      updateAxiosToken(authToken);

      dispatch(getUserData()).then(() => {
        resolve();
      });
    });
  };
};

export const logOut = () => {
  return dispatch => {
    return new Promise(resolve => {
      backendLogOut();

      dispatch({
        type: actionTypes.LOG_OUT,
      });

      removeLocalItem("authToken");

      resolve();
    });
  };
};

export const confirmEmail = (token, email) => {
  return dispatch => {
    return backend
      .request({
        method: "POST",
        url: "/readers/confirm-email/",
        data: {
          token: token,
          email: email,
        },
      })
      .then(() => {
        dispatch({
          type: actionTypes.EMAIL_CONFIRM_SUCCESS,
        });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.EMAIL_CONFIRM_ERROR,
          payload: err,
        });
      });
  };
};
